import { render, staticRenderFns } from "./word-view.vue?vue&type=template&id=4331e9d5&scoped=true&"
import script from "./word-view.vue?vue&type=script&lang=js&"
export * from "./word-view.vue?vue&type=script&lang=js&"
import style0 from "./word-view.vue?vue&type=style&index=0&id=4331e9d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331e9d5",
  null
  
)

export default component.exports